import { type ResolvedSelection } from '@databases/selections-api-types';

/**
 * Extract the row selection type from the discriminated union.
 */
type ResolvedRowSelection = Extract<ResolvedSelection, { mode: 'row' }>;

/**
 * Type guard that checks if the resolved selection is in row mode.
 * Narrows the type to ResolvedRowSelection for type-safe access to entries.
 */
export function isRowSelection(
  resolved: ResolvedSelection | null
): resolved is ResolvedRowSelection {
  return resolved !== null && resolved.mode === 'row';
}

/**
 * Gets entry IDs from a row selection, or returns empty array if not in row mode.
 * Type-safe helper that combines the guard and extraction.
 */
export function getSelectedEntryIds(resolved: ResolvedSelection | null): string[] {
  if (!isRowSelection(resolved)) {
    return [];
  }
  return resolved.entries.map((e) => e.entryId);
}
